import NewsCreate from './NewsCreate';
import NewsEdit from './NewsEdit';
import NewsList from './NewsList';
import NewsShow from './NewsShow';

export default {
  list: NewsList,
  create: NewsCreate,
  edit: NewsEdit,
  show: NewsShow,
};
